var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.908,
    height: 55.908,
    viewBox: "0 0 55.908 55.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3350",
    "data-name": "Group 3350",
    transform: "translate(15881.027 19072.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    transform: "matrix(0.951, -0.309, 0.309, 0.951, -15881.027, -19059.281)",
    fill: "none",
    stroke: "#fc5230",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeDasharray: 17
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.185,
    cy: 22.185,
    r: 22.185,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.185,
    cy: 22.185,
    r: 20.685,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -15868.493, -19055.828)",
    fill: "#fff",
    stroke: "#fc5230",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.311,
    cy: 13.311,
    r: 13.311,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.311,
    cy: 13.311,
    r: 12.311,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCircle);
export default __webpack_public_path__ + "static/media/modal-circle.f4fb12cfed040c9ffe29bcb9990f0d3d.svg";
export { ForwardRef as ReactComponent };